import Navbar from "@components/navbar";
import React from "react";
import Steps from "../components/steps";
import { trpc } from "@utils/trpc";
import { useAnalytics } from "@context/analytics";
import rhtToast from "react-hot-toast";
import HeaderBar from "@components/HeaderBar";
import { useUser } from "@clerk/nextjs";
import noRefetchOptions from "@utils/noRefetchOptions";

export default function HeadstartLayout({ children }: any) {
  const modelMutation = trpc.user.setModel.useMutation();
  const { user } = useUser();
  const { data: fullUser } = trpc.user.me.useQuery(undefined, noRefetchOptions);
  const analytics = useAnalytics();

  const onChange = async (data) => {
    try {
      await modelMutation.mutate(data?.value);
      await analytics.track("Model Changed", { model: data?.value });
      rhtToast.success("Model changed successfully!");
    } catch (err) {
      rhtToast.error("Something went wrong, please try again!");
    }
  };
  return (
    /* This example requires Tailwind CSS v2.0+ */
    <>
      {/* <Navbar onChange={onChange} /> */}
      <HeaderBar
        user={user}
        fullUser={fullUser}
        showPersonaButton={false}
        showLogo
        showOrg={false}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <div className="mx-auto mt-32 flex flex-col md:flex-row space-x-2">
          <Steps />
          {children}
        </div>
      </div>
    </>

    // <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-blue-400"></div>
  );
}
